
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio/[projectSlug]",
      function () {
        return require("private-next-pages/portfolio/[projectSlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portfolio/[projectSlug]"])
      });
    }
  